/* eslint-disable max-len */
/* eslint-disable dot-notation */
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';
import api from '@src/api';

export const getOutingPunchSetting = (): Observable<Action> => (
	api.get('punch-in-records/field-records/setting')
);

type BaseOutingPunchRecord = {
	attachments: { id: string, name: string, created_at?: string }[],
	duty: boolean,
	id: string,
	latitude?: string,
	longitude?: string,
	ip_address?: string,
	ip_or_location_name: string;
	punch_at: string,
	description: string,
	shift_name: string | null
};

type LocationOutingPunchRecord = BaseOutingPunchRecord & {
	punch_in_type: 'location',
	latitude: string,
	longitude: string,
};

type IPOutingPunchRecord = BaseOutingPunchRecord & {
	punch_in_type: 'ip',
	ip_address: string,
};

type QRcodeOutingPunchRecord = BaseOutingPunchRecord & {
	punch_in_type: 'qrcode',
};

export type OutingPunchRecord = LocationOutingPunchRecord | IPOutingPunchRecord | QRcodeOutingPunchRecord;

export const getOutingPunch = (payload): Observable<Action<OutingPunchRecord[]>> => api.get('punch-in-records/field-records', payload, { hasPagination: true });

type BaseOutingPunch = {
	duty: boolean,
	attachment_ids: string[],
  shift_id?: string
	reason: string,
	description: string
}

type LocationOutingPunch = BaseOutingPunch & {
	punch_in_type: 'location',
	location_id: string,
	latitude: number,
	longitude: number,

}

type IPPostOutingPunch = BaseOutingPunch & {
  punch_in_type: 'ip'
  ip_setting_id: string,
}

type QRcodePostOutingPunch = BaseOutingPunch & {
  punch_in_type: 'qrcode';
  qr_code_id: string;
  verify_code: string;
};

export type IPostOutingPunch = LocationOutingPunch | IPPostOutingPunch | QRcodePostOutingPunch;
export const postOutingPunch = (props: IPostOutingPunch): Observable<Action> => (
	api.post('punch-in-records/field-records', props)
);

export const deleteOutingPunch = ({ id }: { id: string }): Observable<Action> => (
	api.delete(`punch-in-records/field-records/${id}`)
);

export const getOutingPunchAttachment = ({ id }: { id: string }): Observable<Action> => (
	api.get(`punch-in-records/field-records/attachments/${id}/download_link`)
);

export const deleteOutingPunchAttachments = ({ id }: { id: string }): Observable<Action> => (
	api.delete(`punch-in-records/field-records/attachments/${id}`)
);

export const postOutingPunchAttachments = (payload: {
	id: string;
	attachment_ids: string[];
}): Observable<Action> => (
	api.post(`punch-in-records/field-records/${payload.id}/attachments`, { attachment_ids: payload.attachment_ids })
);
